import { createAsyncThunk } from '@reduxjs/toolkit'
import ReleaseScheduleAction from './release-schedule-action-model'
import {
  delete_releaseScheduleAction,
  load_releaseScheduleActions,
  store_releaseScheduleAction,
} from './releaseScheduleAction-service'

export const LoadReleaseScheduleActionsAsync = createAsyncThunk<any, any>(
  'composer/load/releaseScheduleAction',
  async (params: { uid: string }) => {
    return await load_releaseScheduleActions(params)
  },
)

export const CreateReleaseScheduleActionAsync = createAsyncThunk<any, any>(
  'composer/create/releaseScheduleAction',
  async (params: ReleaseScheduleAction) => {
    return await store_releaseScheduleAction(params)
  },
)

export const DeleteReleaseScheduleActionAsync = createAsyncThunk<any, any>(
  'composer/delete/releaseScheduleAction',
  async (params) => {
    return await delete_releaseScheduleAction(params)
  },
)
